import { camelCase } from 'change-case';
import { deserialize } from 'deserialize-json-api';

import { transformObjectKeys } from '../../../../../utils/general';

export const deserializeResponseBody =
  (shouldTransformKeys = true) =>
  (data: unknown): unknown => {
    if (
      data &&
      typeof data === 'object' &&
      'data' in (data as Record<string, unknown>)
    ) {
      try {
        const deserialized = deserialize(data as Record<string, unknown>);
        return shouldTransformKeys
          ? transformObjectKeys(deserialized, camelCase)
          : deserialized;
      } catch {
        return data;
      }
    }
    return data;
  };
